export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How can I sign up on the Sikka app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            Follow these steps to sign up on Sikka:
            <ul>
              <li>Click on the Sign Up button.</li>
              <li>Enter your phone number. You will receive an OTP.</li>
              <li>
                Enter the OTP on the Sikka app to become a registered user.
              </li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'What are the methods to earn Sikka on the Sikka app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            Below are the ways you can earn Sikka:
            <ul>
              <li>Complete simple offers</li>
              <li>Refer the Sikka app to your friends</li>
              <li>Spin the wheel daily</li>
              <li>Check in to the app daily</li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'How can I avail of an offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            Follow these steps to avail an offer on Sikka:
            <ul>
              <li>Click on the offer to view the offer details.</li>
              <li>
                Read all the steps carefully and perform all the steps one by
                one.
              </li>
              <li>
                Sikka will be credited to your account once we have verified
                that the tasks are completed.
              </li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'When will the Sikka be added to my wallet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Sikka will be credited to your account once we verify that you have completed all the steps mentioned in the offer.'
      }
    },
    {
      '@type': 'Question',
      name: 'How many Sikka make 1 rupee?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '10 Sikka = 1 Rupee.'
      }
    },
    {
      '@type': 'Question',
      name: 'What is an Ongoing Offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'An Ongoing Offer is one you have completed partially, i.e., where you have not completed all the steps or when we are verifying offer completion.'
      }
    },
    {
      '@type': 'Question',
      name: 'What is an Additional Reward? How can I claim it?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Once you complete the steps given under an offer, you are eligible to avail of the additional reward. You can get it by retaining the app on your phone for a specified period. You can get daily rewards for opening the app every day and claim the remaining reward on the last day.'
      }
    },
    {
      '@type': 'Question',
      name: 'Why wasn’t I able to claim my additional reward?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            Your additional reward may not be credited to your account due to
            one of the following reasons:
            <ul>
              <li>You uninstalled the app before the time mentioned.</li>
              <li>You did not open the app daily.</li>
              <li>You did not click the Redeem button daily.</li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'Why should I provide my phone number while logging in?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You must provide your phone number for OTP verification. Also, the phone number is unique to every user. Thus, it helps in delivering better offers based on the activity.'
      }
    },
    {
      '@type': 'Question',
      name: 'Is there an alternative method of logging in?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Unfortunately, you can only log in by providing your phone number. Since phone numbers are unique to individual users, it helps us provide better offers based on a user’s activity on the application.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are Trending Offers?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Trending Offers are those involving easy steps to complete a task and high chances of getting a reward.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are Highest Paying Offers?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Highest Paying Offers are those with the most reward coins.'
      }
    },
    {
      '@type': 'Question',
      name: 'Why has my offer failed even after completing all the tasks?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            An offer may fail because of the following reasons:
            <ul>
              <li>
                You did not complete the offer before the window of time ended.
              </li>
              <li>You did not complete all the steps.</li>

              <li>We are yet to verify that you have completed the offer.</li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'Can I complete an offer even after its status is Failed?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can complete an offer even if the status is Failed as long as it is active on the app. You will not receive the rewards if the offer is inactive.'
      }
    },
    {
      '@type': 'Question',
      name: 'I completed all the steps on my offer but got no rewards. What was the issue?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'If you completed all the steps and didn’t get any rewards, there might be a tracking issue, and we might not have verified that the offer has been completed. Please write to us at sikkaappofficial@gmail.com with your phone number and offer name, and we will try to solve the issue.'
      }
    },
    {
      '@type': 'Question',
      name: 'What do you mean by Locally Verified status of an offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Locally Verified means that the installation of the offer-related app has been tracked at our end, but we are waiting for a confirmation from the offer-related app for the same.'
      }
    },
    {
      '@type': 'Question',
      name: 'When does the status of my offer change from Locally Verified to Completed?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The offer status changes from Locally Verified to Completed once we confirm that you have completed all the steps mentioned in the offer details. We add the rewards to your Sikka wallet as soon as the status of the offer changes to Completed.'
      }
    },
    {
      '@type': 'Question',
      name: 'How much time does it take to verify once I complete all the steps?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The confirmation is real-time for all the offers, and the reward is added to your wallet. In some exceptional cases, it may take up to 24 hours to complete the verification. If we fail to verify even after 24 hours, the offer status changes to Failed.'
      }
    },
    {
      '@type': 'Question',
      name: 'How can I refer Sikka to my friends?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To refer your friends, go to your profile’s Refer and Earn segment. You will find your referral code at the bottom of the screen, which you can copy and share directly with your friends or via the apps given in the Share list.'
      }
    },
    {
      '@type': 'Question',
      name: 'When will I get the referral reward?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The friend you referred must enter your referral code during signup. Once they have availed and completed three offers after signing in, you and your friend will have the rewards added to your respective wallets.'
      }
    },
    {
      '@type': 'Question',
      name: 'What rewards will my friend and I get if I refer them?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'If you refer a friend and they complete three offers, you get a reward worth 50% of what they earn from the offers.'
      }
    },
    {
      '@type': 'Question',
      name: 'How can I share my referral code with a friend?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can share the referral code through any channel given in the list, or you can copy it and share it through the medium of your preference.'
      }
    },
    {
      '@type': 'Question',
      name: 'How can I go to my wallet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can view your wallet by clicking the Wallet icon in the top section of the app. The amount displayed is the total Sikka you have earned on the app.'
      }
    },
    {
      '@type': 'Question',
      name: 'How can I see my earning history?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Go to the Wallet and click the Earning History tab to check your earning history.'
      }
    },
    {
      '@type': 'Question',
      name: 'What is the amount I can transfer from the Sikka app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'For the first transaction, you can transfer Rs. 5 at a time. From the second transaction onwards, you can transfer Rs. 30 at a time.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are the channels to transfer my money from the Sikka app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You can transfer your money to your bank using your UPI ID.'
      }
    },
    {
      '@type': 'Question',
      name: 'How long will it take to transfer money from Sikka to my bank account?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The transfer usually happens instantly, but the bank may take up to 72 hours or more to process the payment from their side, depending on the circumstances.'
      }
    },
    {
      '@type': 'Question',
      name: 'What are some reasons my money is not getting transferred to my bank account?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: (
          <>
            The possible reasons why your money is not getting transferred to
            your bank account are:
            <ul>
              {/* <li>Your KYC is not complete on Paytm.</li> */}
              {/* <li>
								Your UPI ID is not connected to the Paytm account you use to
								transfer the amount.
							</li> */}
              <li>You may have entered the wrong UPI ID</li>
            </ul>
          </>
        )
      }
    },
    {
      '@type': 'Question',
      name: 'All the requirements for transferring money are fulfilled, but I can still not transfer the money. Why?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'There might be some issue on the bank’s end. You may try transferring the money after 24 hours. If the problem persists, write to us at sikkaappofficial@gmail.com, mentioning your phone number and the issue you are facing.'
      }
    },
    {
      '@type': 'Question',
      name: 'Why was I banned from transferring money?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'You get banned from transferring money from Sikka because we might have detected some unusual activity on your Sikka account. If you think you were incorrectly banned, write to us at sikkaappofficial@gmail.com, mentioning your phone number and the issue you are facing.'
      }
    },
    {
      '@type': 'Question',
      name: 'What is Daily Check-In? How can I avail it?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Daily Checkin is a reward system for users who use Sikka daily. It is a streak-based reward that increases with the continuation of the streak. You can claim it from the app’s home screen by clicking on the Gift icon.'
      }
    }
  ]
};
